module.exports = __webpack_public_path__ + "img/서브_체력.eb95cefc.svg";